import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './styles.module.scss';

const HoverInfo = ({ content }) => {
  const [isHover, setHover] = useState(false);

  return (
    <div
      className={s.menuContainer}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className={s.menuIcon}>
        <input className={s.menuIcon__checkbox} type="checkbox" />
        {isHover && (
          <aside className={s.bubbleContainer}>
            {content.filter(
              (text, idx) =>
                // eslint-disable-next-line react/no-array-index-key
                text && <p key={idx}>{text}</p>,
            )}
          </aside>
        )}
        <div>
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

HoverInfo.propTypes = {
  content: PropTypes.string.isRequired,
};

export default HoverInfo;
